
import Aux from './Aux'
import moment from 'moment'
import { I18n } from '@front/volcanion'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        companyservice_id: record?.companyservice_id,
        client_id: record?.client_id,
        name: record?.name,
        status: Aux.loadStatus(record),
        require_confirmation: record?.require_confirmation,
        customer_ref_format: record?.customer_ref_format,
        schedule_delay: record?.schedule_delay,
        dispatch_priority: record?.dispatch_priority,
        can_call_booker: record?.can_call_booker,
        can_call_driver: record?.can_call_driver,
        password: record?.password,
        new_password: record?.new_password,
        new_password_availableSince: record?.new_password_availableSince,
        require_paymentkey: record?.require_paymentkey,
        deferred_billing: record?.deferred_billing,
        driver_options: _.map(record?.driver_options, 'user_option_id'),
        vehicle_options: _.map(record?.vehicle_options, 'vehicle_option_id'),
        customerref_option: {
          fill_ref_rule: record?.customerref_option?.fill_ref_rule,
          imposed_ref: !record?.customerref_option?.manual_allowed,
          format: record?.customerref_option?.format,
          refs: record?.customerref_option?.refs
        },
        fill_doc_rule: record?.fill_doc_rule,
        comments: {
          driver: _.find(record?.comments, comment => comment?.type?.client_id === 'service_driver')?.text,
          operator: _.find(record?.comments, comment => comment?.type?.client_id === 'service_operator')?.text,
          information: _.find(record?.comments, comment => comment?.type?.client_id === 'service_information')?.text
        },
        contact: {
          email: record?.contact?.email,
          gsm: record?.contact?.gsm,
        },
        availableUntil: record?.availableUntil,
        availableSince: record?.availableSince,
        exclude_heatmap: record?.exclude_heatmap,
        bypass_heatmap_cascade: record?.bypass_heatmap_cascade,
        hide_driverinfo: record?.hide_driverinfo,
        priority: record?.priority,
        excluded_commercial_packages: _.map(record?.excluded_commercial_packages, 'commercial_package_id')
      }
    }
  }

  static formToRecordHandler(companycontract_id, commentB2BCategories, commentTypes, operator) {
    return function formToRecord(values, extra, meta, state) {
      return {
        contract: companycontract_id,
        companyservice_id: values?.companyservice_id,
        client_id: values?.client_id,
        name: values?.name,
        status: Aux.loadStatus(values),
        require_confirmation: values?.require_confirmation,
        customer_ref_format: values?.customer_ref_format,
        schedule_delay: values?.schedule_delay,
        dispatch_priority: values?.dispatch_priority,
        can_call_booker: values?.can_call_booker,
        can_call_driver: values?.can_call_driver,
        password: values?.password,
        new_password: values?.new_password,
        new_password_availableSince: values?.new_password_availableSince,
        require_paymentkey: values?.require_paymentkey,
        deferred_billing: values?.deferred_billing,
        driver_options: values?.driver_options,
        vehicle_options: values?.vehicle_options,
        customerref_option: {
          format: values?.customerref_option?.billing_format,
          refs: values?.customerref_option?.refs,
          fill_ref_rule: values?.customerref_option?.fill_ref_rule,
          manual_allowed: _.isBoolean(values?.customerref_option?.imposed_ref) ? !values?.customerref_option?.imposed_ref : undefined
        },
        fill_doc_rule: values?.fill_doc_rule,
        comments: Aux.exportComments(values?.comments, commentB2BCategories, commentTypes, operator?.user_id),
        contact: {
          email: values?.contact?.email,
          gsm: values?.contact?.gsm,
        },
        ...Aux.exportStatus(values?.status),
        availableUntil: Aux.exportDate(values?.availableUntil, { hour: 0, minute: 0, second: 0 }),
        availableSince: Aux.exportDate(values?.availableSince, { hour: 23, minute: 59, second: 59 }),
        exclude_heatmap: values?.exclude_heatmap,
        bypass_heatmap_cascade: values?.bypass_heatmap_cascade,
        hide_driverinfo: values?.hide_driverinfo,
        priority: values?.priority,
        excluded_commercial_packages: values?.excluded_commercial_packages
      }
    }
  }

  static getEmptyFormHandler(auth_account) {
    return function getEmptyFormValues() {
      return {
        require_paymentkey: false,
        availableSince: moment.utc().format(),
        can_call_booker: true,
        can_call_driver: true,
        customerref_option: {
          imposed_ref: false,
          fill_ref_rule: 'optional'
        },
        fill_doc_rule: 'optional'
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        companycontract_id: record?.contract?.companycontract_id,
        title: record?.name,
        auth_account: record?.contract?.auth_account,
      }
    }
  }

  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return { force_order_cancel: !!extra?.forceSubmit }
    }
  }

  static onSubmitSuccessHandler(requestSubmitSchedules, requestSubmitOrderLimit) {
    return async function onSubmitSuccess(result, values, extra, meta, state) {
      const service = result?.companyservice_id
      !!requestSubmitSchedules && requestSubmitSchedules({ service })
      !!requestSubmitOrderLimit && requestSubmitOrderLimit({ companyservice: service })
    }
  }

  static onSubmitFailedHandler(openDialog) {
    return async function onSubmitFailed(err, values, extra, meta) {
      if (err?.code === 'ACTIVE_JOBS')
        openDialog('show_active_jobs', {
          title: I18n.t('driver.popup.show_active_jobs.pending_orders.title'),
          description: I18n.t('driver.popup.show_active_jobs.pending_orders.description', { entity: I18n.t('driver.popup.show_active_jobs.entity.companyservice') }),
          job_ids: err?.context?.job_ids,
        })
    }
  }
}

export default Callbacks
